import type { ReactNode } from 'react';

type TransactionAmountRowProps = {
    label: ReactNode;
    children: ReactNode;
};

export const TransactionAmountRow = ({
    label,
    children,
}: TransactionAmountRowProps) => (
    <div className="flex items-center justify-between gap-3 px-4 py-2.5">
        {label}
        {children}
    </div>
);
